import React, { useRef } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { getColor, lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DownArrowSvgIcon } from '../../../image/DownArrow.svg';
import { ReactComponent as PlusSvgIcon } from '../../../image/Plus.svg';

export default function LessonBox(props) {
  const { 
    data, 
    setClickLessonData, 
    isClickedLessonEdit, 
    onClickEditLessonButton, 
    onClickDeletedLesson,

    // 움직임 //
    index,
    dataListLength,
    target,
    targetStartY,
    targetEndY,
    emptyHeight,
    clickIndex,
    changedIndex,
    setChangedIndex,
    clickDivision,
    isNotClick,
    setIsNotClick,
    onMouseDown,
    onClickChangeIndex,
    // 움직임 //

  } = props;
  
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const TotalRef = useRef();
  const EmptyRef = useRef();

  // // 움직임 정리 //
  // useEffect(() => {
  //   if (TotalRef === null || target === TotalRef.current || changedIndex === undefined) {
  //     TotalRef.current.style.transform = `translateY(0px)`;
  //     TotalRef.current.style.transition = `none`;
      
  //     return;
  //   }

  //   // 현재 컴포넌트 시작 좌표 //
  //   var myStartY = TotalRef.current.getBoundingClientRect().top;
  //   // 컴포넌트 크기 //
  //   // var myHeight = TotalRef.current.offsetHeight;
  //   // let myHeight = 67;
  //   let myHeight = 52;
  //   // 현재 컴포넌트 끝 좌표 //
  //   var myEndY = myEndY + myHeight;
  //   // 컴포넌트 움직임을 결정할 기준점 //
  //   var standardY = (myStartY + (myHeight / 2));
  //   // 타겟 컴포넌트의 기준점 ( 정중앙 ) //
  //   var targetStandardY = ((targetStartY + targetEndY) / 2);

  //   // 움직임 에니메이션 주기 //
  //   TotalRef.current.style.transition = `all 0.3s ease-in-out`;

  //   // console.log('**************');
  //   // console.log('index : ' + index);
  //   // console.log('clickIndex : ' + clickIndex);
  //   // console.log('changedIndex : ' + changedIndex);
  //   // console.log('targetStartY : ' + targetStartY);
  //   // console.log('targetEndY : ' + targetEndY);
  //   // console.log('절대위치 : ' + myStartY);
  //   // // console.log('크기 : ' + myHeight);
  //   // console.log('기준점 : ' + standardY);
  //   // console.log('**************');
  //   // console.log(TotalRef.current.style.transform);
  //   if (myStartY < 0) return;
  //   // 타겟이 움직여야할 컴포넌트보다 아래에 있을 경우 //
  //   if (clickIndex > index) {
  //     // 가동 범위 내에 있는지 확인 //
  //     if (myStartY < targetStandardY || targetStandardY < myEndY) {
  //       // 타겟의 기준점이 움직임 기준점을 넘기면 이동
  //       if (targetStandardY < standardY) {
  //         TotalRef.current.style.transform = `translateY(${targetEndY - targetStartY + 15}px)`;
  //         // if (idx === 0) console.log("?? : " + idx);
  //         // console.log('=====');
  //         // console.log('target : ' + targetStandardY);
  //         // console.log('standard : ' + standardY);
  //         // console.log('index : ' + index);
  //         setChangedIndex(index);
  //       }
  //       else if (targetStandardY > standardY) {
  //         TotalRef.current.style.transform = `translateY(0px)`;
  //         // if (idx === 0) console.log("!! : " + (idx === dataListLength - 1 ? dataListLength : idx + 1));
  //         setChangedIndex(index === dataListLength - 1 ? dataListLength : index + 1);
  //       }
  //     }
  //   }
  //   // 타겟이 움직여야할 컴포넌트보다 위에 있을 경우 //
  //   else if (clickIndex < index) {
  //     // 가동 범위 내에 있는지 확인 //
  //     if (myStartY < targetStandardY || targetStandardY < myEndY) {
  //       if (targetStandardY > standardY) {
  //         TotalRef.current.style.transform = `translateY(-${targetEndY - targetStartY + 15}px)`;
  //         // if (idx === 0) console.log("** : " + idx);
  //         setChangedIndex(index);
  //       }
  //       // 다시 위로 올라갈경우 제자리로 //
  //       else if (targetStandardY < standardY) {
  //         TotalRef.current.style.transform = `translateY(0px)`;
  //         // if (idx === 0) console.log("^^ : " + (idx === 0 ? 0 : idx - 1));
  //         setChangedIndex(index === 0 ? 0 : index - 1);
  //       }
  //     }
  //   }
  // }, [TotalRef, target, targetStartY, targetEndY, clickDivision, clickIndex, changedIndex, index, dataListLength])

  // 수업 클릭시 //
  function onClickLesson() {
    if (isNotClick) return;

    // setClickLessonData(data);
    onClickEditLessonButton(data);
  }

  // // 수업 수정 클릭시 //
  // function onClickEditLesson() {
  //   onClickEditLessonButton(data);
  // }

  // 이동(동작 번호 및 동작 이름) 버튼 클릭시 //
  function onComponentMouseDown(e) {
    onMouseDown(e, TotalRef.current, index);
  }

  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation(); // ← 버블링 중단!
    onClickChangeIndex('DOWN', index);
  }

  return (
    <TopLevelWrapper>
      { (target === TotalRef.current && target !== undefined) && <EmptyBox ref={EmptyRef} height={emptyHeight} /> }
      <LessonBoxView
        ref={TotalRef}
        onClick={onClickLesson}
        hoverColor={isClickedLessonEdit ? '' : getColor(data.color, isDark)}
        isUnvisible={true}
        $isDark={isDark}
        
        /*onMouseDown={onComponentMouseDown}*/>
        <TextWrapper>
          <ArrowWrapper>
            <ArrowImageWrapper onClick={onClickMoveUp}>
              <StyledUpArrowSvg style={{ color: theme.subText }} />
            </ArrowImageWrapper>
            <ArrowImageWrapper onClick={onClickMoveDown}>
              <StyledDownArrowSvg style={{ color: theme.subText }} />
            </ArrowImageWrapper>
          </ArrowWrapper>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} cursor='pointer'>{data.name}</Text>
        </TextWrapper>
        <StatusWrapper>
          <ImageWrapper>
            <StyledCloseIcon style={{ color: theme.subText }} onClick={(e) => { e.stopPropagation(); onClickDeletedLesson(data); }} />
          </ImageWrapper>
        </StatusWrapper>
      </LessonBoxView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  width: 495px;
`;

const LessonBoxView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // padding: 0px 16px 0px 16px;
  padding: 0px 10px 0px 10px;
  margin: 7.5px 0px 7.5px 0px;

  // width: 463px;
  width: 473px;
  height: 52px;
  min-height: 52px; 

  color: ${props => props.theme.text};

  border-radius: 12px;
  // background-color: ${props => props.isHide ? `#F2F2F2` : `#FFFFFF`};
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.03);

  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${props => props.isUnvisible ? props.theme.text : `#FFFFFF`};
    background-color: ${props => props.hoverColor};
    cursor: pointer;
  }
`;

const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: ${props => props.height === 0 ? `0px 0px 0px 0px` : `7.5px 0px 7.5px 0px`};

  width: 463px;
  // height: 52px;
  // min-height: 52px;
  height: ${props => props.height}px;
  min-height: ${props => props.height}px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 77.75%;

  overflow: hidden;

  gap: 15px;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;
`;

const StyledCloseIcon = styled(PlusSvgIcon)`
  width: 20px;
  height: 20px;

  transform: rotate(45deg);

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledUpArrowSvg = styled(DownArrowSvgIcon)`
  width: 18px;
  height: auto;

  transform: rotate(180deg);

  transition: color 0.3s ease-in-out;
`;

const StyledDownArrowSvg = styled(DownArrowSvgIcon)`
  width: 18px;
  height: auto;

  transition: color 0.3s ease-in-out;
`;
